import { render, staticRenderFns } from "./DemoItem.vue?vue&type=template&id=8fbf3686&scoped=true&"
import script from "./DemoItem.vue?vue&type=script&lang=js&"
export * from "./DemoItem.vue?vue&type=script&lang=js&"
import style0 from "./DemoItem.vue?vue&type=style&index=0&id=8fbf3686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbf3686",
  null
  
)

export default component.exports